import React from 'react';
import Icon from '../Icon'

export default function MaleIcon({ title, fontSize }) {
    return (<Icon icon="businessman" title={title} style={{ color: "blue", fontSize: fontSize || "16px", paddingRight: "4px" }} />);
};